import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  policyContainer: {
    maxHeight: 340,
    overflowY: 'auto',
    borderRadius: 4,
    padding: 16,
  },
}))
